export default __webpack_public_path__ + "static/media/img-0047.38ac2e7c.png";